export default __webpack_public_path__ + "static/media/cocoMall.aad5d667.png";